// PortfolioCompany.js

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import "./portfolioCompany.css";
import "../../common/css/layout.css";
import InvestmentDetails from "./InvestmentDetails";
import Metrics from "./Metrics";
import MetricsHistory from "./MetricsHistory";
import Sentiment from "./Sentiment";
import { GetPortfolioCompanyById } from "../../common/api/PortcoAPIHelper";
import { fetchPortfolioById } from '../../common/helpers/PortfolioCompanyHelper';
import InvestorDetails from './InvestorDetails';
import {PITCHBOOK_INVESTORS } from '../../common/util/constants';

const PortfolioCompany = () => {
  let { portcoId } = useParams();
  const [companyName, setCompanyName] = useState('');
  const [portfolioDetails, setPortfolioDetails] = useState(null);

  useEffect(() => {
    const fetchCompany = async () => {
      const company = await GetPortfolioCompanyById(portcoId);
      if (company) {
        setCompanyName(company.company_name);
      }
    };

    fetchCompany();
  }, [portcoId]);

  useEffect(() => {
    const fetchDetails = async () => {
      const details = await fetchPortfolioById(portcoId);
      setPortfolioDetails(details);
    };

    fetchDetails();
  }, [portcoId]);

  return (
    <div className="all-components-container">
      <div className="component-no-border component-in-row-1">
        <div className="component-heading ra__portco_sectionheading">
          <h2>{companyName}</h2>
        </div>
      </div>
      <div className="hr_line"></div>
      <div className="component component-in-row-2">
        {portfolioDetails && <InvestmentDetails portfolioDetails={portfolioDetails} />}
      </div>
      <div className="component component-in-row-2 metricshistory">
        <div className="component-heading ra__portco_componentheading">Other Investors</div>
        {portfolioDetails && portfolioDetails.portfolioInsights && <InvestorDetails investors={portfolioDetails.portfolioInsights.find(insight => insight.insight_code === PITCHBOOK_INVESTORS)} />}
        <div className="data-source-heading-light">Data Source: Pitchbook</div>
        <div className="hr_line"></div>
        <div className="component-heading ra__portco_componentheading">Internally Tracked Metrics</div>
        <MetricsHistory portcoId={portcoId}/>
        <div className="component-heading ra__portco_componentheading">Internally Tracked Sentiment</div>
        <MetricsHistory portcoId={portcoId} metricCode="SENTIMENT"/>
      </div>
      <div className="hr_line"></div>
      <div className="component component-in-row-2">
        <Metrics portcoId={portcoId}/>
      </div>
      <div className="component component-in-row-2">
      <Sentiment portcoId={portcoId}/>
      </div>
    </div>
  )  
}

export default PortfolioCompany;
